import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const GreenCheckIcon = (props: IconProps) => (
  <Icon width="144px" height="150px" viewBox="0 0 144 150" {...props}>
    <ellipse
      cx="71.9438"
      cy="72.9911"
      fill="#D9F2E0"
      opacity="0.5"
      rx="69.5954"
      ry="69.8661"
    />
    <path
      fill="#B3E5C0"
      d="M58.047 100.68 37.8032 80.3571l-6.8935 6.8717L58.047 114.472l58.256-58.4824-6.845-6.8717L58.047 100.68Z"
    />
    <path
      fill="#40BF62"
      d="M57.6022 95.3225 37.3584 75l-6.8936 6.8716 27.1374 27.2434 58.2558-58.4826-6.845-6.8717-51.4108 51.5618Z"
    />
  </Icon>
);

export default memo(GreenCheckIcon);
